var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"upper",attrs:{"variant":this.$i18n.locale !== _vm.language ? 'link' : 'light',"disabled":this.$i18n.locale === _vm.language},on:{"click":function($event){return _vm.changeOnlyOneParam('locale', _vm.language)}}},[_vm._v(" "+_vm._s(_vm.language)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }